import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { WorkOrderModuleCategoriesSettings } from 'lane-shared/domains/workOrder';
import {
  buildCategoryItems,
  buildIssueTypeItems,
  findSelectedCategory,
  DropdownOption,
} from './coverageHoursPanelUtils';

type UseCoverageHoursPanelOptionsResult = {
  categoryItems: DropdownOption[];
  selectedCategory: WorkOrderModuleCategoriesSettings | undefined;
  issueTypeItems: DropdownOption[];
};

export function useCoverageHoursPanelOptions(
  categories: WorkOrderModuleCategoriesSettings[],
  categoryValue: string | null
): UseCoverageHoursPanelOptionsResult {
  const { t } = useTranslation();

  const categoryItems = useMemo(
    () => buildCategoryItems(categories),
    [categories]
  );

  const selectedCategory = useMemo(
    () => findSelectedCategory(categories, categoryValue),
    [categories, categoryValue]
  );

  const issueTypeItems = useMemo(
    () => buildIssueTypeItems(selectedCategory, t),
    [selectedCategory, t]
  );

  return { categoryItems, selectedCategory, issueTypeItems };
}
